var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CoreContainer',[_c('router-view',{attrs:{"slot":"module"},slot:"module"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }